import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getSchoolProfile = ({ schoolId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/school-profile/he-school/${schoolId}/profile/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSchoolMajors = ({ schoolId, version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/school-profile/he-school/${schoolId}/he-school-majors/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentMajors = ({ schoolId, version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/school-profile/he-school/${schoolId}/student-majors/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSchoolApplication = ({ schoolId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/school-profile/he-school/${schoolId}/application/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSchoolAthletics = ({ schoolId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/school-profile/he-school/${schoolId}/athletics/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSchoolsInConference = ({ conferenceId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/school-profile/athletic-conference/${conferenceId}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);
